import * as React from 'react';
import { useDispatch } from 'react-redux';

import { GeoLocationButton } from './GeoLocationButton';
import { closeOfferPreview } from '../../../../../common/actions/closeOfferPreview/closeOfferPreview';
import { pushErrorNotification } from '../../../../../common/actions/notifications';
import { useApplicationContext } from '../../../../../common/containers/ApplicationContext';
import { EErrorNotificationType } from '../../../../../common/types/notifications';
import { TThunkDispatch } from '../../../../../common/types/redux';
import { useControlsContext } from '../context';

export const GeoLocationButtonContainer: React.FC = props => {
  const dispatch = useDispatch<TThunkDispatch>();
  const { map, ymaps } = useControlsContext();
  const { logger } = useApplicationContext();

  const handleGeoLocationError = React.useCallback(
    (error: Error) => {
      logger.error(error, { domain: 'Controls/GeoLocationButton/handleGeoLocationClick()' });

      dispatch(pushErrorNotification(EErrorNotificationType.GeoLocation));
    },
    [logger, dispatch],
  );

  const handleGeoLocationClick = React.useCallback(() => {
    dispatch(closeOfferPreview());
  }, [dispatch]);

  return (
    <GeoLocationButton
      {...props}
      map={map}
      ymaps={ymaps}
      onGeoLocationClick={handleGeoLocationClick}
      onGeoLocationError={handleGeoLocationError}
    />
  );
};
